query GetUserAiFeatureSettings($userId: ID!) {
    user(id: $userId) {
        id
        isAiFollowUpTasksEnabled
    }
}
